import { createFileRoute } from "@tanstack/react-router";

import CreateProductForm from "@/components/organisms/products/CreateProductForm";

const CreateProduct = () => {
  return <CreateProductForm />;
};

export const Route = createFileRoute("/_authenticated/_sidebarLayout/product/create")({
  component: CreateProduct,
});
